import React from "react";
import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import GlobalStyles from "@mui/material/GlobalStyles";

import { queryClient, persister } from "./store/serverStore";
import { logger } from "./utils/logger";
import getGlobalStyles from "./globalStyles";
import { SnackbarProvider } from "widgets";
import ErrorFallback from "containers/ErrorFallBack/ErrorFallback";
import Routes from "Routes";
import Header from "shared/Header/Header";

const App = () => {
  const theme = createTheme();

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={logger}>
      <ThemeProvider theme={theme}>
        <GlobalStyles styles={getGlobalStyles()} />
        <SnackbarProvider>
          <PersistQueryClientProvider
            client={queryClient}
            persistOptions={{ persister }}
          >
            <BrowserRouter>
            <Header/>
            <Routes/>
            </BrowserRouter>
          </PersistQueryClientProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
